export default "__VITE_PUBLIC_ASSET__fff1637f__"